// PERF-1: loads and plays only the visible deferred banner video.
// The logo-banner renders a desktop video and a mobile video, both in the DOM
// with CSS hiding one; without this, phones download BOTH 1080p files. Videos
// render with <source data-src> (nothing fetched at parse time); this attaches
// the real source to whichever video is visible at the current viewport size.
// The poster attribute paints immediately either way, so the hero is never blank.
(function () {
  // Attaches the deferred source to one video and starts it. Idempotent: a
  // video that is already loaded is left alone. Returns true when the video
  // has its source (attached now or earlier), false when there was nothing
  // to attach.
  function attachDeferredVideo(video) {
    if (video.dataset.loaded) return true;
    // PERF-4: the gallery also calls this on slide change; an interaction
    // video under reduced motion keeps its poster there too.
    if (isInteractionTriggered(video) && reducedMotion()) return false;
    var source = video.querySelector("source[data-src]");
    if (!source) return false;
    source.src = source.dataset.src;
    video.dataset.loaded = "1";
    video.load();
    video.muted = true;
    video.play().catch(function () {});
    return true;
  }

  // PERF-2: the product gallery (gallery.js) calls this for the deferred PDP
  // hero when Swiper brings that slide back into view, so the attach logic
  // lives in exactly one place.
  window.deferredVideoAttach = attachDeferredVideo;

  // PERF-4: a video marked data-deferred-trigger="interaction" (the product
  // hero) is not started at DOMContentLoaded. It waits for the shopper's first
  // scroll, touch, pointer press or key, so the lab (which never interacts)
  // keeps the poster as the LCP element and records no moving frames. Real
  // visitors almost all scroll within seconds, so they still get the loop.
  // Under prefers-reduced-motion such a video is never started at all.
  var INTERACTION_SELECTOR = 'video[data-deferred-trigger="interaction"]';
  var INTERACTION_EVENTS = ["scroll", "touchstart", "pointerdown", "keydown"];

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function isInteractionTriggered(video) {
    return video.getAttribute("data-deferred-trigger") === "interaction";
  }

  function loadVisibleDeferredVideos() {
    document
      .querySelectorAll("video[data-deferred-video]")
      .forEach(function (video) {
        if (video.dataset.loaded) return;
        if (isInteractionTriggered(video)) return; // waits for the shopper
        if (video.offsetParent === null) return; // CSS-hidden for this viewport
        attachDeferredVideo(video);
      });
  }

  // Runs once. The elements are looked up at fire time, not at arm time,
  // because the product gallery rebuilds its slides after init and the
  // parse-time element may have been replaced by a clone by then. No
  // visibility check: if the tab is hidden the source still attaches and
  // the browser plays when it becomes visible. No timer fallback.
  var interactionArmed = false;
  function onFirstInteraction() {
    INTERACTION_EVENTS.forEach(function (name) {
      window.removeEventListener(name, onFirstInteraction);
    });
    if (reducedMotion()) return;
    document.querySelectorAll(INTERACTION_SELECTOR).forEach(function (video) {
      attachDeferredVideo(video);
    });
  }

  function armInteractionStart() {
    if (interactionArmed) return;
    if (!document.querySelector(INTERACTION_SELECTOR)) return;
    interactionArmed = true;
    INTERACTION_EVENTS.forEach(function (name) {
      window.addEventListener(name, onFirstInteraction, { passive: true });
    });
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(loadVisibleDeferredVideos, 250);
  }

  function onReady() {
    loadVisibleDeferredVideos();
    armInteractionStart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
  window.addEventListener("resize", onResize);
})();
